<div class="section-container" id="experience">
  <div class="section-left">
    <h2>{{strings.experience}}</h2>
  </div>

  <div class="section-right">
    <div class="experiences-section-wrapper">
      <div class="section-title">
        <h2 [innerHTML]="strings.experienceSectionTitle"></h2>
      </div>
      <div class="experiences-section-content">
        <div class="experiences-titles">
          <h3 class="experience-company">{{strings.experienceCompany}}</h3>
          <h3 class="experience-title">{{strings.experienceTitle}}</h3>
          <h3 class="experience-duration">{{strings.experienceDuration}}</h3>
          <h3 class="experience-view"></h3>
        </div>
        <div class="experiences-wrapper" *ngFor="let experience of strings.language == 'en' ? experiences.en : experiences.ba; trackBy: trackByFn">
          <div class="experience-wrapper">
            <h3 class="experience-company">{{experience.company}}</h3>
            <h3 class="experience-title">{{experience.title}}</h3>
            <h3 class="experience-duration">{{experience.from + " - " + experience.to}}</h3>
            <button type="button" class="experience-view" (click)="viewExperience(experience)">{{strings.experienceView}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

